import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Report} from '../../../interfaces/interfaces';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {SnackBarService} from '../../../services/utils/snackBar.service';
import {ReportListService} from '../../../services/report-list/report-list.service';
import {environment} from '../../../../../environments/environment';
import {EmployerService} from '../../../services/modules/employer.service';

export interface DialogData {
  idEmployer: string;
}

@Component({
  selector: 'app-dialog-sending-reports',
  templateUrl: './dialog-sending-reports.component.html',
  styleUrls: ['./dialog-sending-reports.component.scss']
})
export class DialogSendingReportsComponent implements OnInit {
  report: Report;
  s3Bucket: string;
  CompanyInfoId: string;
  removable = true;
  formVincularUser: FormGroup;

  companyUsersTrue: any[] = [];
  companyUsersFalse: any[];
  selectedSearchuserVincular: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private fb: FormBuilder,
    private snackBService: SnackBarService,
    private reportListService: ReportListService,
    private employerService: EmployerService,
    public dialogRef: MatDialogRef<DialogSendingReportsComponent>,

  ) { }

  ngOnInit(): void {
    this.s3Bucket = environment.api.s3Bucket;
    this.formVincularUser = this.fb.group({
      Email: new FormControl(''),
    });
    this.report = this.reportListService.reports.find( report => report.id === 100);
    this.employerService.getSendEmailById(this.data.idEmployer).subscribe((res: any) => {
      this.companyUsersTrue = res.filter((user: any) => user.isContractor === true);
      this.companyUsersFalse = res.filter((user: any) => user.isContractor === false);
    });
  }

  searchgetUserByEmail(): void {
    const emailControl = this.formVincularUser.get('Email');
    if (!emailControl) {
      return;
    }
    const rawValue = emailControl.value;
    const email = typeof rawValue === 'string' ? rawValue.trim() : '';
    const foundUser = this.companyUsersFalse.find(u => u.Email === email);
    if (foundUser) {
      this.selectedSearchuserVincular.push(foundUser);
      emailControl.reset();
    } else {
      this.snackBService.openWarning('No se encontró el correo!', '', 3000);
    }
  }

  close() {
    this.dialogRef.close({confirm: false});
  }

  saveSendingReports(){
    const contractorEmails = this.companyUsersTrue.map((user: any) => user.Email);
    const allEmails = [
      ...(this.selectedSearchuserVincular.map((user: any) => user.Email) || []),
      ...contractorEmails
    ];
    this.dialogRef.close({
      confirm: true,
      emails: allEmails
    });
  }

  onRemoveCompanyUser(user: { Email: string }) {
    if (this.companyUsersTrue.length > 1 || this.selectedSearchuserVincular.length > 0) {
      const idx = this.companyUsersTrue.indexOf(user);
      if (idx >= 0) {
        this.companyUsersTrue.splice(idx, 1);
      }
    }
  }

  onRemoveAdicionarUser(user: { Email: string }): void {
    const idx = this.selectedSearchuserVincular.indexOf(user);
    if (idx >= 0) {
      this.selectedSearchuserVincular.splice(idx, 1);
    }
  }




}
